// TODO Delete this and all deps after release new position slots
export const POSITION_SLOT_API_OFFICE_LABELS: Dictionary<string> = {
  AUSTIN: 'Austin',
  MINSK: 'Minsk',
  KRAKOW: 'Krakow',
};

export const POSITION_SLOT_API_OFFICE_OPTIONS = Object.entries(POSITION_SLOT_API_OFFICE_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  }),
);
//

export const OFFICE = {
  AUSTIN_1: 'AUSTIN_1',
  MINSK_1: 'MINSK_1',
  KRAKOW_1: 'KRAKOW_1',
  TBILISI_1: 'TBILISI_1',
};

export const OFFICE_LABEL = {
  [OFFICE.AUSTIN_1]: 'Austin',
  [OFFICE.MINSK_1]: 'Minsk',
  [OFFICE.KRAKOW_1]: 'Krakow',
  [OFFICE.TBILISI_1]: 'Tbilisi',
};

export const POSITION_SLOT_OFFICES_CHECKBOX_SX = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '16px',
  mb: 0,
  '& .label__wrapper': {
    mb: 0,
  },
  '& .MuiFormGroup-root': {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: '16px',
    rowGap: '4px',
  },
  '& .MuiFormControl-root.checkbox-form-group': {
    marginBottom: 0,
    width: 'auto',
  },
  '& .MuiFormHelperText-root:empty': {
    display: 'none',
  },
};
